module.exports = __webpack_public_path__ + "static/media/hall-sph706-1.284809b6.png";